<div class="form-container">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="4">
       
        <div class="formLabelSemiBoldfs16 mb-5" style="margin: 10px;"> Add Training Programme </div>
      </ion-col>

      <ion-col size="8" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>

    <!-- addprogram-form.component.html -->
    <form [formGroup]="addProgramForm" style="margin: 10px;">
      <ion-row>
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">
            Dept<span class="red-cl">&nbsp;*</span>
          </div>
          <ng-multiselect-dropdown class="w-100 mat mat-height40 mat-input-style"
          [placeholder]="'Select Department'"
          [settings]="dropdownSettings"
          [data]="getDepartmentsList"      
          formControlName="department"
          (onSelect)="onDepartmentSelect()"
          (onDeSelect)="onDepartmentDeSelect()"
          (onSelectAll)="onDepartmentAllSelect()"
          (onDeSelectAll)="onDepartmentAllDeSelect()">
        </ng-multiselect-dropdown>
        </ion-col>
        
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Programme Title <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="programTitle" placeholder="Enter title" />
            <mat-error *ngIf="addProgramForm.get('programTitle')?.hasError('required') && addProgramForm.get('programTitle')?.touched">
              Program title is required
            </mat-error>
          </mat-form-field>
        </ion-col>

        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Programme Details <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="programDetails" placeholder="Enter title" />
            <mat-error *ngIf="addProgramForm.get('programDetails')?.hasError('required') && addProgramForm.get('programDetails')?.touched">
              Program Details is required
            </mat-error>
          </mat-form-field>
        </ion-col>

        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Start Date <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput  [matDatepicker]="picker1" formControlName="startDate" placeholder="select start Date"/>
            <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
            <mat-error *ngIf="addProgramForm.get('startDate')?.hasError('required') && addProgramForm.get('startDate')?.touched">
              Start date is required
            </mat-error>
          </mat-form-field>
        </ion-col>

        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">End Date <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput [matDatepicker]="picker2"  formControlName="endDate" placeholder="select End Date"/>
            <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
          <mat-error *ngIf="addProgramForm.get('endDate')?.hasError('required') && addProgramForm.get('endDate')?.touched">
            End date is required
          </mat-error>
          </mat-form-field>
        </ion-col>

        

    <ion-col size="4" class="mt-10">
  <div class="formLabelRegularfs16 mb-5">Upload brochure <span class="red-cl">*</span></div>
  <mat-form-field class="w-100 mat-height40 mat-input-style" appearance="fill">
    <input type="file" hidden (change)="onFileSelected($event)" #fileInput>
    <input matInput [value]="selectedFileName" placeholder="Upload brochure" readonly (click)="fileInput.click()"  formControlName="brochure">
    <button mat-icon-button matSuffix (click)="fileInput.click()" type="button">
      <mat-icon>attach_file</mat-icon>
    </button>
    <mat-error *ngIf="fileUploadError">
      Brochure file is required
    </mat-error>
  </mat-form-field>
</ion-col>


      </ion-row>

      <ion-row>
        <ion-col size="12" class="text-right mt-10">
          <button class="back_btn fs-14" (click)="closeDialog()">Cancel</button>
          <button type="button" class="add_btn fs-14 ml-10"
          [style.background-color]="buttonColorName"  (click)="submitTrainingProgram()">
<!--      
          {{ data?.programData ? 'Update' : 'Submit' }} -->
          Create Training
          </button>
        </ion-col>
      </ion-row>
    </form>

  </div>
</div>